module.exports = __webpack_public_path__ + "static/img/bg.6b449ce7.svg";